import { useParams } from 'react-router-dom';
import { invariant } from '@utils/invariant';
import useSWR from 'swr';

import { Breadcrumb } from '../../../components/Breadcrumb';
import { PageHeader } from '../../../components/PageHeader';
import { fetchCustomerPortalLocation } from './models';
import { DataField } from '../../../components/DataField';
import { useTranslation } from '../../../contexts/translation-context';
import { PageHeading } from 'components/PageHeading';
import { ErrorState } from '../../../components/error-state/ErrorState';
import { getDisplayError } from '../../../utils/get-display-error';

export const CustomerPortalLocationPage = () => {
  const { locationId } = useParams<{ locationId: string }>();
  invariant(locationId);
  const { i18n } = useTranslation();
  const {
    data: location,
    error,
    mutate,
  } = useSWR(['customer-portal-location', +locationId], () => fetchCustomerPortalLocation(+locationId));

  if (!location) {
    return (
      <ErrorState
        error={error}
        title={error ? i18n('errors.loadingTitle') : i18n('customerPortal.locations.locationNotFound')}
        description={
          error
            ? i18n('customerPortal.locations.couldNotLoadLocation', { error: getDisplayError(error) })
            : i18n('errors.notFoundDescription')
        }
        onRetry={error ? () => mutate() : undefined}
        variant="page"
      />
    );
  } else {
    return (
      <>
        <PageHeader title={location.name} />

        <div>
          <PageHeading
            leftSide={
              <Breadcrumb
                parentItem={{
                  name: i18n('customerPortal.locations.locations'),
                  to: '..',
                }}
                currentItem={location.name}
              />
            }
          />

          <div className="card p-4 mx-4">
            <DataField title={i18n('customerPortal.locations.language')}>{location.language}</DataField>

            <DataField title={i18n('customerPortal.locations.address')}>
              <div>{`${location.street} ${location.streetNumber}`}</div>
              <div>{`${location.country}${location.postalCode} ${location.city}`}</div>
            </DataField>
          </div>
        </div>
      </>
    );
  }
};
